import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-mobile",
  "use": "icon-mobile-usage",
  "viewBox": "0 0 12.1 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 12.1 12\" id=\"icon-mobile\">\r\n<path d=\"M8.6,0.2H3.5c-0.6,0-1.1,0.5-1.1,1.1v9.4c0,0.6,0.5,1.1,1.1,1.1h5.1c0.6,0,1.1-0.5,1.1-1.1V1.3C9.6,0.7,9.2,0.2,8.6,0.2z\r\n\t M4.6,0.8h2.9v0.4H4.6V0.8z M6,11.1c-0.4,0-0.7-0.3-0.7-0.7S5.6,9.6,6,9.6s0.7,0.3,0.7,0.7S6.4,11.1,6,11.1z M8.9,8.9H3.1V1.7h5.8\r\n\tV8.9z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/mobile.svg
// module id = ofrD
// module chunks = 171